"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Timeline = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var useractivity_timeline_formatter_1 = require("./useractivity-timeline-formatter");
var browser_detection_1 = require("@braintree/browser-detection");
var systemactivity_timeline_formatter_1 = require("./systemactivity-timeline-formatter");
var ActivityType;
(function (ActivityType) {
    ActivityType["USER"] = "USER";
    ActivityType["SYSTEM"] = "SYSTEM";
    ActivityType["CQA"] = "CQA";
})(ActivityType || (ActivityType = {}));
var Timeline = function (props) {
    var _a;
    var raw = ui_common_1.activity.convertActivityToTimeline(props.items, (_a = {},
        _a[ActivityType.USER] = useractivity_timeline_formatter_1.userActivityFormatter,
        _a[ActivityType.SYSTEM] = systemactivity_timeline_formatter_1.systemActivityFormatter,
        _a[ActivityType.CQA] = systemactivity_timeline_formatter_1.cqaActivityFormatter,
        _a));
    if ((raw === null || raw === void 0 ? void 0 : raw.length) === 0) {
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message" }, { children: "No activity." }));
    }
    var items = raw.map(function (item, itemIdx) {
        var tiles = item.tiles.map(function (tile, idx) {
            var _a;
            var subTitle = tile.subtitle ? ((0, jsx_runtime_1.jsxs)("p", __assign({ className: "tile-subtitle" }, { children: ["On ", tile.subtitle, ":"] }))) : (false);
            var titles = !((_a = tile.titles) === null || _a === void 0 ? void 0 : _a.length)
                ? false
                : tile.titles.map(function (title, titleIdx) { return ((0, jsx_runtime_1.jsx)("p", __assign({ className: "tile-title" }, { children: title }), titleIdx)); });
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "tile" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "tile-content" }, { children: [subTitle, titles] })) }), idx));
        });
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "timeline-item" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-left" }, { children: (0, jsx_runtime_1.jsx)("a", { className: "timeline-icon" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-content" }, { children: tiles }))] }), itemIdx));
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "cmx-timeline timeline" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "timeline-meta" }, { children: (0, browser_detection_1.isIe11)()
                    ? 'All times listed in UTC'
                    : 'All times listed are in your timezone' })), items] })));
};
exports.Timeline = Timeline;
Timeline.displayName = 'Timeline';
//# sourceMappingURL=timeline.js.map